module.exports = "/images/aiBot.svg?9aae8da2c7bb75e92f60151936c3ddcb";